module.exports = __webpack_public_path__ + "static/media/move-backward-tool.761b306e.svg";